import { render } from "./ClientTalkPanel.vue?vue&type=template&id=17ecf79a&scoped=true"
import script from "./ClientTalkPanel.vue?vue&type=script&lang=js"
export * from "./ClientTalkPanel.vue?vue&type=script&lang=js"

import "./ClientTalkPanel.vue?vue&type=style&index=0&id=17ecf79a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17ecf79a"]])

export default __exports__